module.exports = __webpack_public_path__ + "img/diamond-3-no-shine.dd027bb1.png";